import { createContext, useContext, useState } from "react";
import { SelectedEntity } from "../../Models/SelectedEntity";

interface SelectedEntityProviderProps {
  children: React.ReactNode;
}

type SelectedEntityContextType = {
  selectedEntity?: SelectedEntity;
  setSelectedEntity: (selectedEntity: SelectedEntity) => void;
  preselectedEntity?: SelectedEntity;
  setPreselectedEntity: (preselectedEntity: SelectedEntity) => void;
};

export const SelectedEntityContext = createContext<SelectedEntityContextType>({
  selectedEntity: undefined,
  setSelectedEntity: () => {},
  preselectedEntity: undefined,
  setPreselectedEntity: () => {},
});

const SelectedEntityProvider = (props: SelectedEntityProviderProps) => {
  const [selectedEntity, setSelectedEntity] = useState<SelectedEntity>();
  const [preselectedEntity, setPreselectedEntity] = useState<SelectedEntity>();

  return (
    <SelectedEntityContext.Provider
      value={{
        selectedEntity,
        setSelectedEntity,
        preselectedEntity,
        setPreselectedEntity,
      }}
    >
      {props.children}
    </SelectedEntityContext.Provider>
  );
};

export default SelectedEntityProvider;

export const useSelectedEntity = () => {
  const {
    selectedEntity,
    setSelectedEntity,
    preselectedEntity,
    setPreselectedEntity,
  } = useContext(SelectedEntityContext);
  return {
    selectedEntity,
    setSelectedEntity,
    preselectedEntity,
    setPreselectedEntity,
  };
};
